// IMPORT REACT
import React from "react";
import Axios from "axios";

// IMPORT CONTAINERS
import Layout from '../../Layout';

// IMPORT COMPONENTS
import YAContainer from '../../../components/Grid/Container';
import YASection from '../../../components/Grid/Section';
import YARow from '../../../components/Grid/Row';
import YAColumn from '../../../components/Grid/Column';
import YAText from '../../../components/Text';
import YAButton from '../../../components/Form/Button';
import YAResourceList from '../../../components/ResourceList';

// IMPORT STYLES
// import {} from '../../styles';

const Resources = ({ lang, page, bloginfo }) => {
  return (
    <Layout lang={lang} page={page} bloginfo={bloginfo}
      header={
        <Header page={page} bloginfo={bloginfo} />
      }
      body={
        <div>
          <SectionMiddle page={page} lang={lang} />
        </div>
      }
    />
  );
}

const Header = ({ page, bloginfo }) => (
  <div>
    <YARow center>
      <YAColumn size="col-md-8 col-lg-6">
        <YAText tag="h1" bootstrap="display-4 mb-3">
          {page ? page.post_title : null}
        </YAText>
        <YAText tag="p" bootstrap="lead">
          {page ? page['meta']['page_section_0_text'] : null}
        </YAText>
      </YAColumn>
    </YARow>
  </div>
);

const SectionMiddle = ({ page, lang }) => (
  <YASection padding={{'top': '0'}}>
    <YAContainer>
      <YARow center>
        <YAColumn size="col-md-10 col-lg-8">
          <YAText tag="h2" addOn={
            <YAButton href={page ? page['meta']['resources_section_1_button_link'] : null} 
              color="outline-primary"
            >
              {page ? page['meta']['resources_section_1_button_text'] : null}
            </YAButton>
            }>
            {page ? page['meta']['resources_section_1_heading'] : null}
          </YAText>
        </YAColumn>
        <YAColumn size="col-md-10 col-lg-8">
          <YAResourceList page={page} lang={lang} />
        </YAColumn>
      </YARow>
    </YAContainer>
  </YASection>
);

export default Resources;